import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { PersonService } from './person/service/person.service';
import { AuthenticationService } from './authentication/service/authentication.service';
import { NameMatchSearchCtxService } from './nzor/service/name-match-search-ctx.service';
import { BatchControlService } from './batch/service/batch-control.service';
import { NZORNameDetailsService } from './nzor/service/nzorname-details.service';
import { NZORNameService } from './nzor/service/nzorname.service';
import { ReportService } from './report/service/report.service';
import { AssessmentService } from './assessment/service/assessment.service';
import { ReportSearchCtxService } from './report/service/report-search-ctx.service';
import { AssessmentSearchCtxService } from './assessment/service/assessment-search-ctx.service';
import { TagService } from './tag/service/tag.service';
import { User } from './authentication/service/user';
import { ReportOptionsService } from './report/service/report-options.service';
import { SpeciesService } from './species/service/species.service';
import { SpeciesNzorNameService } from './species/service/species-nzor-name.service';
import { CommentService } from './comments/service/comment.service';
import { AssessmentExportService } from './assessment/service/assessment-export.service';
import { StatisticsService } from './statistics/service/statistics.service';
import { CodeValueService } from './code/service/code-value.service';
import { HomeService } from './home/service/home.service';
import { SpeciesNameService } from './report/report-detail/species-selector/species-name.service';
import { LoginComponent } from './authentication/login/login.component';
import { VersionData, VersionService } from './version/version.service';
import { NztcsSpeciesSearchCtxService } from './nztcs-species/nztcs-species-search/nztcs-species-search-ctx.service';
import { faSignInAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { NztcsSpeciesService } from './nztcs-species/service/nztcs-species.service';
import {disableRum, enableRum, rum} from './aws-rum';
import {AwsRum} from 'aws-rum-web';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    PersonService,
    NameMatchSearchCtxService,
    BatchControlService,
    CodeValueService,
    CommentService,
    NZORNameDetailsService,
    NZORNameService,
    ReportService,
    ReportSearchCtxService,
    ReportOptionsService,
    AssessmentService,
    AssessmentSearchCtxService,
    AssessmentExportService,
    TagService,
    SpeciesNameService,
    SpeciesNzorNameService,
    SpeciesService,
    NztcsSpeciesService,
    NztcsSpeciesSearchCtxService,
    StatisticsService,
    HomeService,
  ],
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild('loginComponent', { static: true })
  loginComponent: LoginComponent;

  currentUser: User;
  tokenWatcherInterval: any;

  versionData: VersionData;

  loginIcon = faSignInAlt;
  logoutIcon = faSignOutAlt;

  isCollapsed = true;
  isUsingCollapsed = true;
  isSearchCollapsed = true;
  isAdminCollapsed = true;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private versionService: VersionService
  ) {}

  ngOnInit(): void {
    this.authenticationService.currentUser$.subscribe(
      (currentUser) => (this.currentUser = currentUser)
    );

    this.versionService
      .getVersion()
      .subscribe((versionData) => {
        this.versionData = versionData;

        if (this.versionData.rumId && this.versionData.rumRegion) {
          enableRum(this.versionData.rumId, this.versionData.rumRegion, this.versionData.rumPoolId);
        } else {
          disableRum();
        }
      });


    this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd && rum !== null) {
        if (rum instanceof Promise) {
          await rum;
        }

        if (rum) {
          (rum as AwsRum).recordPageView(this.router.url);
        }
      }
    });
  }

  ngAfterViewInit(): void {
  }

  isActive(path: string): boolean {
    return this.router.url.indexOf(path) > -1;
  }

  isLoggedIn() {
    return this.currentUser && this.currentUser.token;
  }

  isLoginLinkVisible() {
    return !this.isLoggedIn();
  }

  isLogoutLinkVisible() {
    return this.isLoggedIn();
  }

  onLogin() {
    this.authenticationService.login();
  }

  onLogout() {
    this.authenticationService.logout();
    this.router.navigate(['home']);
  }

  isNameDisplayed() {
    return this.authenticationService.isLoggedIn();
  }

  toggleUsing() {
    this.isUsingCollapsed = !this.isUsingCollapsed;
    if (!this.isUsingCollapsed) {
      this.isSearchCollapsed = true;
      this.isAdminCollapsed = true;
    }
  }

  toggleSearch() {
    this.isSearchCollapsed = !this.isSearchCollapsed;
    if (!this.isSearchCollapsed) {
      this.isUsingCollapsed = true;
      this.isAdminCollapsed = true;
    }
  }

  toggleAdmin() {
    this.isAdminCollapsed = !this.isAdminCollapsed;
    if (!this.isAdminCollapsed) {
      this.isUsingCollapsed = true;
      this.isSearchCollapsed = true;
    }
  }
}
